// ** React Imports
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const Layout = () => {
  // ** Hooks
  return (
    <Box>
      <>
        <Outlet />
      </>
    </Box>
  );
};

export default Layout;
